export default function Addition() {
  return (
    <div className="p-4">
      <h1>Addition</h1>
    </div>
  );
}
